import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import "vanilla-cookieconsent/dist/cookieconsent.js"
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import { getTranslate } from '../../Helper/GetTranslate';

export class Footer extends Component {




    componentDidMount() {
        const cookieConsent = window.initCookieConsent()
        cookieConsent.run({
            current_lang: localStorage.getItem("language"),
            autoclear_cookies: true,                   // default: false
            page_scripts: true,                        // default: false

            // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
            // delay: 0,                               // default: 0
            auto_language: false,                     // default: null; could also be 'browser' or 'document'
            // autorun: true,                          // default: true
            // force_consent: false,                   // default: false
            // hide_from_bots: true,                   // default: true
            // remove_cookie_tables: false             // default: false
            // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
            // cookie_expiration: 182,                 // default: 182 (days)
            // cookie_necessary_only_expiration: 182   // default: disabled
            // cookie_domain: location.hostname,       // default: current domain
            // cookie_path: '/',                       // default: root
            // cookie_same_site: 'Lax',                // default: 'Lax'
            // use_rfc_cookie: false,                  // default: false
            // revision: 0,                            // default: 0

            onFirstAction: function (user_preferences, cookie) {
                // callback triggered only once
            },

            onAccept: function (cookie) {
                // ...
            },

            onChange: function (cookie, changed_preferences) {
                // ...
            },

            languages: {
                'en': {
                    consent_modal: {
                        title: 'We use cookies!',
                        description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" className="cc-link">Let me choose</button>',
                        primary_btn: {
                            text: 'Accept all',
                            role: 'accept_all'              // 'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text: 'Reject all',
                            role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                        }
                    },
                    settings_modal: {
                        title: 'Cookie preferences',
                        save_settings_btn: 'Save settings',
                        accept_all_btn: 'Accept all',
                        reject_all_btn: 'Reject all',
                        close_btn_label: 'Close',
                        cookie_table_headers: [
                            { col1: 'Name' },
                            { col2: 'Domain' },
                            { col3: 'Expiration' },
                            { col4: 'Description' }
                        ],
                        blocks: [
                            {
                                title: 'Cookie usage ',
                                description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" className="cc-link">privacy policy</a>.'
                            }, {
                                title: 'Strictly necessary cookies',
                                description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                                toggle: {
                                    value: 'necessary',
                                    enabled: true,
                                    readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                                }
                            }, {
                                title: 'Performance and Analytics cookies',
                                description: 'These cookies allow the website to remember the choices you have made in the past',
                                toggle: {
                                    value: 'analytics',     // your cookie category
                                    enabled: false,
                                    readonly: false
                                },
                                cookie_table: [             // list of all expected cookies
                                    {
                                        col1: '^_ga',       // match all cookies starting with "_ga"
                                        col2: 'google.com',
                                        col3: '2 years',
                                        col4: 'description ...',
                                        is_regex: true
                                    },
                                    {
                                        col1: '_gid',
                                        col2: 'google.com',
                                        col3: '1 day',
                                        col4: 'description ...',
                                    }
                                ]
                            }, {
                                title: 'Advertisement and Targeting cookies',
                                description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                                toggle: {
                                    value: 'targeting',
                                    enabled: false,
                                    readonly: false
                                }
                            }, {
                                title: 'More information',
                                description: 'For any queries in relation to our policy on cookies and your choices, please <a className="cc-link" href="#yourcontactpage">contact us</a>.',
                            }
                        ]
                    }
                },
                "tr": {
                    "consent_modal": {
                        "title": "Çerezleri Kullanıyoruz!",
                        "description": "Merhaba, bu web sitesi düzgün çalışmasını sağlamak için zorunlu çerezler ve nasıl etkileşimde bulunduğunuzu anlamak için izleme çerezleri kullanır. İzleme çerezleri yalnızca onay verdikten sonra etkinleştirilecektir. <button type=\"button\" data-cc=\"c-settings\" className=\"cc-link\">Tercihleri Seç</button>",
                        "primary_btn": {
                            "text": "Tümünü Kabul Et",
                            "role": "accept_all"
                        },
                        "secondary_btn": {
                            "text": "Tümünü Reddet",
                            "role": "accept_necessary"
                        }
                    },
                    "settings_modal": {
                        "title": "Çerez Tercihleri",
                        "save_settings_btn": "Ayarları Kaydet",
                        "accept_all_btn": "Tümünü Kabul Et",
                        "reject_all_btn": "Tümünü Reddet",
                        "close_btn_label": "Kapat",
                        "cookie_table_headers": [
                            { "col1": "Adı" },
                            { "col2": "Alan Adı" },
                            { "col3": "Süresi" },
                            { "col4": "Açıklama" }
                        ],
                        "blocks": [
                            {
                                "title": "Çerez Kullanımı",
                                "description": "Web sitemin temel işlevlerini sağlamak ve çevrimiçi deneyiminizi geliştirmek için çerezler kullanıyorum. Her kategori için istediğiniz zaman katılım sağlayabilir veya devre dışı bırakabilirsiniz. Çerezler ve diğer hassas verilerle ilgili daha fazla bilgi için lütfen <a href=\"#\" className=\"cc-link\">gizlilik politikamızı</a> okuyun."
                            },
                            {
                                "title": "Kesinlikle Gerekli Çerezler",
                                "description": "Bu çerezler web sitemin doğru şekilde çalışması için gereklidir. Bu çerezler olmadan web sitesi düzgün çalışmaz.",
                                "toggle": {
                                    "value": "necessary",
                                    "enabled": true,
                                    "readonly": true
                                }
                            },
                            {
                                "title": "Performans ve Analitik Çerezleri",
                                "description": "Bu çerezler, web sitesinin geçmişte yaptığınız tercihleri hatırlamasını sağlar.",
                                "toggle": {
                                    "value": "analytics",
                                    "enabled": false,
                                    "readonly": false
                                },
                                "cookie_table": [
                                    {
                                        "col1": "^_ga",
                                        "col2": "google.com",
                                        "col3": "2 yıl",
                                        "col4": "açıklama ...",
                                        "is_regex": true
                                    },
                                    {
                                        "col1": "_gid",
                                        "col2": "google.com",
                                        "col3": "1 gün",
                                        "col4": "açıklama ..."
                                    }
                                ]
                            },
                            {
                                "title": "Reklam ve Hedefleme Çerezleri",
                                "description": "Bu çerezler, web sitesini nasıl kullandığınız, hangi sayfaları ziyaret ettiğiniz ve hangi bağlantılara tıkladığınız hakkında bilgi toplar. Tüm veriler anonimdir ve kimliğinizi belirlemek için kullanılamaz.",
                                "toggle": {
                                    "value": "targeting",
                                    "enabled": false,
                                    "readonly": false
                                }
                            },
                            {
                                "title": "Daha Fazla Bilgi",
                                "description": "Çerez politikamız ve tercihlerinize ilişkin her türlü soru için lütfen <a className=\"cc-link\" href=\"#yourcontactpage\">bizimle iletişime geçin</a>."
                            }
                        ]
                    }
                }

            }
        });
    }



    render() {


        const translate = getTranslate().footerMenu
        return (
            <>
                <footer id="footer">
                    <div className="container">
                        <div className="footer-inner wow pixFadeUp">
                            <div className="row">
                                <div className="col-lg-3 col-md-6">
                                    <div className="widget footer-widget">
                                        <h3 className="widget-title">{translate.industries.industries}</h3>

                                        <ul className="footer-menu">
                                            <li><Link to="/Industries/Tours-And-Activities">{translate.industries.tour_and_activities}</Link></li>
                                            <li><Link to="/Industries/Trips">{translate.industries.trip}</Link></li>
                                            <li><Link to="/Industries/Attractions">{translate.industries.attractions}</Link></li>
                                            <li><Link to="/Industries/Transportation">{translate.industries.transportation}</Link></li>
                                            <li><Link to="/Industries/Charters">{translate.industries.charters}</Link></li>
                                            <li><Link to="/Industries/Event-and-shows">{translate.industries.events_and_shows}</Link></li>
                                            <li><Link to="/Industries/Workshops-and-classes">{translate.industries.workshops_classes}</Link></li>
                                        </ul>
                                    </div>

                                </div>


                                <div className="col-lg-3 col-md-6">
                                    <div className="widget footer-widget">
                                        <h3 className="widget-title">{translate.partners.partners}</h3>

                                        <ul className="footer-menu">
                                            <li><Link to="/Partners/Travel-Agencies">{translate.partners.travel_agencies}</Link></li>
                                            <li><Link to="/Partners/Airlines">{translate.partners.airlines}</Link></li>
                                            <li><Link to="/Partners/Hotels">{translate.partners.hotels_and_concierges}</Link></li>
                                            <li><Link to="/Partners/Travel-bloggers-affiliate-partners">{translate.partners.travel_blogger}</Link></li>
                                            <li><Link to="/Partners/DMO">{translate.partners.dmos}</Link></li>
                                            <li><Link to="/Partners/DMC">{translate.partners.dmcs}</Link></li>
                                            <li><Link to="/Partners/OTA">{translate.partners.otas}</Link></li>
                                            <li><Link to="/Partners/Cruises">{translate.partners.cruises}</Link></li>
                                            <li><Link to="/Partners/Car-Rental">{translate.partners.car_rentals}</Link></li>
                                            <li><Link to="/Partners/Visitor-Centers">{translate.partners.visitor_centers}</Link></li>

                                        </ul>
                                    </div>

                                </div>


                                <div className="col-lg-3 col-md-6">
                                    <div className="widget footer-widget">
                                        <h3 className="widget-title">{translate.solutions.solutions}</h3>

                                        <ul className="footer-menu">
                                            <li><Link to="/Solutions/Partner-solutions">{translate.solutions.Partnership}</Link></li>
                                            <li><Link to="/Solutions/Distribution">{translate.solutions.distribution}</Link></li>
                                            <li style={{ height: "30px" }}></li>
                                        </ul>

                                        <h3 className="widget-title">{translate.partners_login.partners_login}</h3>
                                        <ul className="footer-menu">
                                            <li><a href="https://partners.tourzone.com/Login" rel='noreferrer' target="_blank">{translate.partners_login.supplier_login}</a></li>
                                            <li><a href="https://partners.tourzone.com/Login" rel='noreferrer' target="_blank">{translate.partners_login.travel_agency_login}</a></li>
                                            {/* <li><Link to="/Help">Help</Link></li>*/}
                                        </ul>

                                    </div>

                                </div>


                                <div className="col-lg-3 col-md-6">
                                    <div className="widget footer-widget">
                                        <h3 className="widget-title">{translate.company.company}</h3>
                                        <ul className="footer-menu">
                                            <li><Link to="/Company">{translate.company.about_us}</Link></li>
                                            <li><Link to="/Contact">{translate.company.contact}</Link></li>
                                            <li><Link to="/Blog">{translate.company.blog}</Link></li>
                                        </ul>
                                        <h3 className="widget-title">{translate.legal.legal}</h3>

                                        <ul className="footer-menu">
                                            <li><Link to="/Pre-Contractual-Form">{translate.legal.pre_contractual}</Link></li>
                                            <li><Link to="/Privacy-policy">{translate.legal.privacy_policy_gdpr}</Link></li>
                                            <li><Link to="/Supplier-Terms-and-Conditions">{translate.legal.supplier_terms}</Link></li>
                                            <li><Link to="/General-Terms-and-Conditions">{translate.legal.general_terms}</Link></li>
                                            <li><Link to="/Distance-Selling-Contract">{translate.legal.distance_Selling}</Link></li>
                                            {/* 
                                            <li><Link to="/Contact">{translate.legal.terms_and_conditions}</Link></li>
                                            <li><Link to="/Privacy-policy">{translate.legal.privacy_policy}</Link></li>
                                            <li><Link to="/Contact">{translate.legal.acceptable_user_policy}</Link></li>
                                            <li><Link to="/Contact">{translate.legal.terms_of_service}</Link></li>
                                           */}
                                        </ul>





                                    </div>

                                </div>

                            </div>


                        </div>

                        <div className="site-info align-items-center pt-3 pb-3">
                            <ul className="footer-social-link">
                                <li><img src="/Assets/img/visa.svg" style={{ height: "25px" }} alt='cc'></img></li>
                                <li><img src="/Assets/img/mastercard.svg" style={{ height: "25px" }} alt='cc'></img></li>
                                <li><img src="/Assets/img/amex.svg" style={{ height: "25px" }} alt='cc'></img></li>
                            </ul>
                            <ul className="footer-social-link">
                                <li></li>
                                <li><a href="https://www.instagram.com/tourzoneofficial" rel='noreferrer' target="_blank"><i className="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>

                        <div className="site-info">
                            <div className="copyright">
                                <p>{translate.copyrights}<a href="https://www.tourzone.com" rel='noreferrer' target="_blank">Tourzone</a></p>

                            </div>


                            <ul className="site-info-menu">
                                <li>{translate.companyId} </li>

                            </ul>
                        </div>
                    </div>
                </footer>

            </>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)